{
  "getEdcMapping": {
    "message": "EDC mapping retrieved successfully",
    "mappings": [
      {
        "auxiliusColumnName": "Subject ID",
        "edcColumnName": "Subject",
        "file": "VIS",
        "includes": "Scheduled Visits",
        "inputCount": 1,
        "notes": "–",
        "outputCount": 1
      },
      {
        "auxiliusColumnName": "Site #",
        "edcColumnName": "Site",
        "file": "VIS",
        "includes": "Scheduled Visits",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Description",
        "edcColumnName": "Visit",
        "file": "VIS",
        "includes": "Scheduled Visits",
        "inputCount": 1,
        "notes": "–",
        "outputCount": 1
      },
      {
        "auxiliusColumnName": "Completion date",
        "edcColumnName": "Date - Date of Visit",
        "file": "VIS",
        "includes": "Scheduled Visits",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Filter out Not Done",
        "edcColumnName": "VISND - Not Done",
        "file": "VIS",
        "includes": "Scheduled Visits",
        "inputCount": null,
        "notes": "Did visit occur?",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Subject ID",
        "edcColumnName": "Patient Number",
        "file": "ENR",
        "includes": "Screen Failures & Patient Group Discontinuation",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Description",
        "edcColumnName": "Visit",
        "file": "ENR",
        "includes": "Screen Failures & Patient Group Discontinuation",
        "inputCount": null,
        "notes": "Only pull in screen Failures & D...",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Completion Date",
        "edcColumnName": "Visit date",
        "file": "ENR",
        "includes": "Screen Failures & Patient Group Discontinuation",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Patient Group",
        "edcColumnName": "Cohort",
        "file": "ENR",
        "includes": "Screen Failures & Patient Group Discontinuation",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Subject ID",
        "edcColumnName": "Subject",
        "file": "UNSCHF",
        "includes": "Unscheduled Visit File",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Site #",
        "edcColumnName": "Site",
        "file": "UNSCHF",
        "includes": "Unscheduled Visit File",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      },
      {
        "auxiliusColumnName": "Completion Date",
        "edcColumnName": "Visit date",
        "file": "UNSCHF",
        "includes": "Unscheduled Visit File",
        "inputCount": null,
        "notes": "–",
        "outputCount": null
      }
    ],
    "success": true
  }
}
